/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Description_Export_Status_Vo_Failed_AtInputs */

const en_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to export audio VO at event index ${i?.index}`)
};

const fr_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l'export de la VO à l'index d'événement ${i?.index}`)
};

const de_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Exportieren der Audio-Sprachausgabe beim Ereignisindex ${i?.index}`)
};

const it_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile esportare l'audio VO all'indice evento ${i?.index}`)
};

const ru_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось экспортировать аудиозапись события с индексом ${i?.index}`)
};

const es_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo exportar el audio VO en el índice de evento ${i?.index}`)
};

const zh_cn2_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出事件索引为 ${i?.index} 的音频 VO 失败`)
};

const ja_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント インデックス ${i?.index} のオーディオ VO をエクスポートできませんでした`)
};

const hi_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट इंडेक्स ${i?.index} पर ऑडियो VO निर्यात करने में विफलता`)
};

const pt_pt2_audio_description_export_status_vo_failed_at = /** @type {(inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao exportar o áudio VO no índice de evento ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Failed to export audio VO at event index {index}" |
*
* @param {Audio_Description_Export_Status_Vo_Failed_AtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_vo_failed_at = /** @type {((inputs: Audio_Description_Export_Status_Vo_Failed_AtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Vo_Failed_AtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_vo_failed_at(inputs)
	if (locale === "de") return de_audio_description_export_status_vo_failed_at(inputs)
	if (locale === "it") return it_audio_description_export_status_vo_failed_at(inputs)
	if (locale === "ru") return ru_audio_description_export_status_vo_failed_at(inputs)
	if (locale === "es") return es_audio_description_export_status_vo_failed_at(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_vo_failed_at(inputs)
	if (locale === "ja") return ja_audio_description_export_status_vo_failed_at(inputs)
	if (locale === "hi") return hi_audio_description_export_status_vo_failed_at(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_vo_failed_at(inputs)
	return en_audio_description_export_status_vo_failed_at(inputs)
});